export default {
  init() {
    // JavaScript to be fired on the home page
    const evtstaysBlock = $('.evtstays-block');
    if (evtstaysBlock.length) {
      const spinnerWrapper = evtstaysBlock.find('.spinner-wrapper');
      const contentWrapper = evtstaysBlock.find('.content-wrapper');

      setTimeout(function() {
        spinnerWrapper.hide();
        contentWrapper.show();
      }, 3000);
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/evtstays.js